import httpService from "./httpService";
import utils from "./utils";

export default {
  findAll(usingAdvanceSearch, keyword, bookId, form, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(
      utils.merge(
        {
          usingAdvanceSearch: usingAdvanceSearch,
          keyword: keyword,
          bookId: bookId
        },
        form
      ),
      pageable
    );

    return httpService.get("vbOutgoingDocInBookView", {params: params});
  },

  findAll2(form, pageable) {
    let params = utils.merge(form, utils.initPageableParams(pageable));
    return httpService.get("vbOutgoingDocInBookView", {params: params});
  },

  countAllForConfigLD(form) {
    return httpService.get("vbOutgoingDocInBookView/count", {params: form});
  },

  count(usingAdvanceSearch, keyword, bookId, form) {
    let params = utils.merge(
      {
        usingAdvanceSearch: usingAdvanceSearch,
        keyword: keyword,
        bookId: bookId
      },
      form
    );

    return httpService.get("vbOutgoingDocInBookView/count", {
      params: params
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/vbOutgoingDocInBookViewService.js